module.exports = __webpack_public_path__ + "static/media/pdf-file.bb7639af.svg";